import { usePopper } from 'react-popper';
import type { Options } from '@popperjs/core';

const ELEMENT_TOOLBAR_POPPER_OPTIONS: Partial<Options> = {
  placement: 'bottom',
  modifiers: [
    {
      name: 'preventOverflow',
      options: {
        tether: true,
        altAxis: true,
      },
    },
    {
      name: 'flip',
      options: {
        fallbackPlacements: ['top'],
      },
    },
    {
      name: 'offset',
      options: {
        offset: [0, 8], // To keep the toolbar from touching the bottom of the screen when scrolling.
      },
    },
  ],
};

export const useElementToolbarPopper = (
  referenceElement: HTMLElement | null,
  popperElement: HTMLElement | null
) => {
  return usePopper(
    referenceElement,
    popperElement,
    ELEMENT_TOOLBAR_POPPER_OPTIONS
  );
};
